<cdx-card [padding]="padding" class="recipeStamp">
	<a [routerLink]="recipePath" class="recipeStamp-link" [attr.aria-labelledby]="labelledBy" (click)="handleStampClick()">
		<div class="recipeStamp-imageContainer" [ngClass]="{ 'recipeStamp-imageContainer--loading': imageLoading }">
			<img
				deferLoad
				class="recipeStamp-image"
				[ngClass]="{ 'recipeStamp-image--loading': imageLoading }"
				[fallback]="fallbackImageUrl"
				[src]="stamp.recipe.imageUrl"
				(load)="imageLoading = false"
				[attr.aria-labelledby]="'recipe-' + stamp.recipe.id + '-title'"
			/>
		</div>
		<div class="recipeStamp-header">
			<div class="recipeStamp-title">
				<recipe-meal-times *ngIf="!isMealPlanStamp()" [id]="stamp.recipe.id" [mealTimes]="stamp.recipe.mealTimes" [limit]="true"></recipe-meal-times>
				<p class="recipeStamp-title" id="recipe-{{ stamp.recipe.id }}-title">{{ stamp.recipe.title }}</p>
			</div>
			<recipe-prep-summary
				[cookDuration]="stamp.recipe.cookDuration"
				[prepDuration]="stamp.recipe.prepDuration"
				[servings]="!isMealPlanStamp() && stamp.recipe.servings"
				[mode]="prepMode"
				[id]="stamp.recipe.id"
			></recipe-prep-summary>
			<recipe-badge *ngIf="stamp.recipe.badge" [title]="stamp.recipe.badge.title" [color]="stamp.recipe.badge.colour"></recipe-badge>
		</div>
	</a>
	<div class="recipeStamp-secondaryActions">
		<button
			cdxButton
			fillStyle="flat"
			(click)="saveClick()"
			[attr.aria-label]="saveButtonText"
			[title]="stamp.recipe.saved ? 'Remove from Saved Recipes' : 'Save recipe'"
		>
			<cdx-icon-circle [name]="stamp.recipe.saved ? 'heart-filled' : 'heart-thick'" background="light" iconFill="green" size="extra-small"></cdx-icon-circle>

		</button>
	</div>
	<div class="recipeStamp-mealPlanning" *ngIf="isMealPlanStamp() && !useCustomActions">
		<button *ngIf="!stamp.mealPlan?.addedServings" cdxButton [fullWidth]="true" (click)="handleAddServing(stamp, initialServings)" i18n="@@recipe-stamp-add-meal" data-cy="addMeal">Add this meal</button>

		<ng-container *ngIf="stamp.mealPlan?.addedServings">
			<product-quantity-selector
				[id]="'quantity-' + stamp.recipe.id"
				unit="none"
				i18n-customLabel="@@quantity-selector-label-serves"
				customLabel="Serves"
				[disableKeyboardInput]="true"
				[quantityResponse]="{ increment: 0.5, value: stamp.mealPlan?.addedServings }"
				(incrementEmitter)="handleAddServing(stamp, 0.5)"
				(decrementEmitter)="handleRemoveServing(stamp, 0.5)"
			></product-quantity-selector>
		</ng-container>
	</div>

	<div *ngIf="useCustomActions" class="recipeStamp-useCustomActions">
		<ng-content select="[customActions]"></ng-content>
	</div>
</cdx-card>
